/**
 * Normalises ID comparison (String vs ObjectId) so lookups work reliably.
 */
export const sameId = (a, b) => String(a) === String(b);

const MONGODB_OBJECT_ID_HEX = /^[0-9a-fA-F]{24}$/;

/**
 * Returns a 24-character hex MongoDB ObjectId string, or "" if missing/invalid.
 * Handles Extended JSON {$oid}, nested _id, and plain strings.
 */
export function extractMongoObjectIdHex(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") {
    const t = value.trim();
    return MONGODB_OBJECT_ID_HEX.test(t) ? t : "";
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const t = String(value);
    return MONGODB_OBJECT_ID_HEX.test(t) ? t : "";
  }
  if (typeof value === "object") {
    if (typeof value.$oid === "string") {
      const t = value.$oid.trim();
      return MONGODB_OBJECT_ID_HEX.test(t) ? t : "";
    }
    if (value._id != null) return extractMongoObjectIdHex(value._id);
  }
  try {
    const s = String(value);
    if (s === "[object Object]") return "";
    return MONGODB_OBJECT_ID_HEX.test(s) ? s : "";
  } catch {
    return "";
  }
}
